export default [
    {
        path: '/warehouse/fulfillment-request',
        name: 'fulfillment-request',
        props: true,
        component: () => import('@/views/warehouse/fulfillment-request/index.vue'),
        meta: {
            pageTitle: 'Fulfillment Request',
            breadcrumb: [
                {
                text: 'Fulfillment Request',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/fulfillment-request/:id',
        name: 'detail-fulfillment-request',
        props: true,
        component: () => import('@/views/warehouse/fulfillment-request/detail.vue'),
        meta: {
            pageTitle: 'Detail Fulfillment Request',
            breadcrumb: [
                {
                text: 'Fulfillment Request',
                to: { name: 'fulfillment-request' },
                },
                {
                text: 'Detail Fulfillment Request',
                active: true,
                },
            ],
        },
    },
]